import { render, staticRenderFns } from "./WorkPdfHost.vue?vue&type=template&id=12962aac&scoped=true"
import script from "./WorkPdfHost.vue?vue&type=script&lang=js"
export * from "./WorkPdfHost.vue?vue&type=script&lang=js"
import style0 from "./WorkPdfHost.vue?vue&type=style&index=0&id=12962aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12962aac",
  null
  
)

export default component.exports